import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import ContactForm from '../../mixins/ContactForm';
import Form from '../../utils/Form';
import {makeFormData, simpleObjectCopy} from '../../utils/miscellanea';
import {State} from '../../utils/fetch';
import {success, warning} from '../../utils/Toast';
import * as basicLightbox from 'basiclightbox';
import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';
import Event from '../../utils/Event';
import {delay} from '../../utils/async';

declare function ym(a: number, b: string, c: string): void;

const template = `
  <div class="pp pp--grey">
    <div class="pp__close menu__sndw  menu__sndw--active" @click="$emit('close')"></div>
    <div class="">
    <div class="pp__title pp__title--v3 frch3-title">
                    Оставьте свои контактные данные, и мы свяжемся с вами в рабочее время</div>
    <div class="pp__form form form--th2">
      <div class="form__ctrl ">
        <input
          type="text" placeholder="Ваше имя*" class="form__input"
          v-model="form.data.name"
          :class="{'form__input--error': form.errors.has('name')}"
        >
      </div>
      <div class="form__ctrl">
        <input
          type="text" placeholder="Е-мейл*" class="form__input"
          v-model="form.data.email"
          :class="{'form__input--error': form.errors.has('email')}"
        >
      </div>
        <div class="form__ctrl">
        <input
          type="text" placeholder="Город/регион*" class="form__input"
          v-model="form.data.region"
          :class="{'form__input--error': form.errors.has('region')}"
        >
        </div>
        <div class="form__ctrl">
        <input
                type="text"
                placeholder="+7 (___) ___-__-__"
                class="form__input"
                v-mask="'+7 (###) ###-##-##'"
                v-model="form.data.phone"
                :class="{'form__input--error': form.errors.has('phone')}"
        />
        </div>
        <div class="form__ctrl">
          <label
            class="checkbox"
            :class="{'checkbox--error': form.errors.has('agreement')}"
          >
            <input type="checkbox" v-model="form.data.agreement">
            <span>
              <sup>
                Согласие на обработку <a href="#" @click.stop.prevent="openAgreement">персональных данных</a>
              </sup>
            </span>
          </label>
        </div>
        
        <div class="form__ctrl" @click="send">
            <div class="branch__form-btn">
                Отправить
            </div>
        </div>
    </div>
    </div> 
  </div>
`;

interface ContactData {
  name: string;
  email: string;
  phone: string;
  region: string;
  agreement: boolean;
}

@Component({
  template: template,
})
export default class FormRequestCallback extends mixins(ContactForm) {

  public form = new Form<ContactData>({
    phone: '',
    region: '',
    name: '',
    email: '',
    agreement: false
  });

  protected requiredFields = ['name', 'email', 'phone', 'region', 'agreement'];
  private lbInstance!: basicLightbox.BasicLightBox | null;

  public async send() {
    this.checkForm();

    if (!this.isFormReady) return;

    this.isLoading = true;

    const form = makeFormData(simpleObjectCopy(this.form.data));
    form.append(this._token, '1');
    form.append('type', '5');

    const response = await this._http.fetchJSON<any>(`/index.php?option=com_xcm&task=send_message`, {
      method: 'POST',
      body: form
    });

    this.isLoading = false;

    if (response.state == State.SUCCESS) {
      success('Сообщение отправлено');
      if (typeof ym === 'function') {
        ym(87096784, 'reachGoal', 'zakaz_zvonok');
      }
      this.form.errors.clear();
      this.form.clear();
    } else {
      warning(response.message, 'Ошибка');
    }
  }

  async mounted() {
    Event.listen('close-agreement', () => {
      this.lbInstance?.close();
    });

    this._token = document.querySelector<HTMLElement>('#token')?.innerText || '';
  }

  openAgreement() {
    this.lbInstance = basicLightbox.create(
      document.querySelector(`#agreement`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }
}
